/**This component is to raise a ticket */

import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./RaiseTicket.css";
import { getData } from "../../../Services/ProfileServices";
import {
  getCategory,
  getSubIssueTypes,
  getResMethods,
  createGrievance,
  getThemeURL,
  grievanceDepartmentslist,
  getAllSLA,
  getAllPriority,
  findAllChildrenRegionsById,
} from "../../../Services/EndPoints";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  postDataWithBody,
  postDataWithFiles,
} from "../../../Services/Services";
import Modal from "react-bootstrap/Modal";
import Loader from "react-spinner-loader";



const RaiseTicket = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isTextFieldDisable } = location.state || {};
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [subject, setSubject] = useState("");
  const [fileErrors, setFileErrors] = useState([]);
  const [userId, setUserId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [userLevel, setUserLevel] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [userProfiles, setUserProfiles] = useState([]);
  const [isPrefilled, setIsPrefilled] = useState(false);
  const [areFieldsEnabled, setAreFieldsEnabled] = useState(true);

  // Region state
  const [weatherDropdownOptions, setWeatherDropdownOptions] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(false);
  const [selectedRegionValue, setSelectedRegionValue] = useState("");
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [stateId, setStateId] = useState(null);

  // Priority / SLA state
  const [priorities, setPriorities] = useState([]);
  const [priorityTime, setPriorityTime] = useState(null);
  const [displayTime, setDisplayTime] = useState("");
  const [defaultDateTime, setDefaultDateTime] = useState("");

  const [formData, setFormData] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    resolutionMethodId: "",
    subject: "",
    description: "",
    issueTypeId: "",
    issueTypeSubCatId: "",
    ticketDateAndTimeString: "",
    resSLADateAndTimeString: "",
    priority: "",
    assignedTeam: "",
    departmentId: "",
    departmentName: "",
    region: [],
  });

  // Validation errors
  const [validationErrors, setValidationErrors] = useState({
    customerName: "",
    phoneNumber: "",
    email: "",
    resolutionMethodId: "",
    subject: "",
    description: "",
    issueTypeId: "",
    issueTypeSubCatId: "",
    ticketDateAndTimeString: "",
    resSLADateAndTimeString: "",
    priority: "",
    assignedTeam: "",
    resolutionDateTime: "",
    region: "",
  });

  const [issueTypes, setIssueTypes] = useState([]);
  const [subIssueTypes, setSubIssueTypes] = useState([]);
  const [resMethods, setResMethods] = useState([]);
  const MAX_LENGTH = 750;
  const [characterCount, setCharacterCount] = useState(0);
  const [showCancelModal, setShowCancelModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [roleList, setRoleList] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [grievanceType, setGrievanceType] = useState("bank");
  // eslint-disable-next-line no-unused-vars
  const [userProfile, setUserProfile] = useState(null);

  // ─── Static icon/color map for categories ───
  const categoryStyleMap = {
    "flood":          { icon: "🌊", color: "#E3F2FD", border: "#90CAF9" },
    "landslide":      { icon: "⛰️", color: "#FBE9E7", border: "#FFAB91" },
    "weather":        { icon: "🌦️", color: "#E8F5E9", border: "#A5D6A7" },
    "infrastructure": { icon: "🏗️", color: "#FFF3E0", border: "#FFE082" },
    "health":         { icon: "🏥", color: "#FCE4EC", border: "#F48FB1" },
    "others":         { icon: "⚠️", color: "#F3E5F5", border: "#CE93D8" },
  };
  const defaultStyle = { icon: "📌", color: "#F5F5F5", border: "#BDBDBD" };

  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategoryCardSelect = (card) => {
    setSelectedCategory(card.label);
    setFormData((prev) => ({
      ...prev,
      issueTypeId: card.id.toString(),
      issueTypeSubCatId: "",
      assignedTeam: card.department_id ? card.department_id.toString() : "",
      departmentId: card.department_id || "",
      departmentName: card.department_name || "",
    }));
    fetchSubIssueTypes(card.id);
    setValidationErrors((prev) => ({
      ...prev,
      issueTypeId: "",
      assignedTeam: "",
    }));
  };

  // ─── Region builder ───
  const buildRegionOptions = async () => {
    setDropdownLoading(true);
    try {
      const userProfileData = await getData(getThemeURL);
      const state_id = userProfileData[0]?.state_id;
      setStateId(state_id);

      fetchIssueTypes(state_id);
      fetchResolutionMethods(state_id);

      const districtsList = await postDataWithBody(
        findAllChildrenRegionsById,
        [state_id],
        {}
      );
      if (!districtsList || !Array.isArray(districtsList)) {
        setWeatherDropdownOptions([]);
        return;
      }

      const options = [];
      for (const district of districtsList) {
        options.push({
          label: district.name,
          value: `district-${district.id}`,
          type: "district",
          regionId: district.id,
          districtName: district.name,
        });
        try {
          const blocks = await postDataWithBody(
            findAllChildrenRegionsById,
            [district.id],
            {}
          );
          if (blocks && Array.isArray(blocks)) {
            blocks.forEach((block) => {
              options.push({
                label: block.name,
                value: `block-${block.id}`,
                type: "block",
                regionId: block.id,
                districtName: district.name,
              });
            });
          }
        } catch (err) {
          console.error(`Error fetching blocks for district ${district.name}:`, err);
        }
      }
      setWeatherDropdownOptions(options);
    } catch (error) {
      console.error("Error building region options:", error);
      setWeatherDropdownOptions([]);
    } finally {
      setDropdownLoading(false);
    }
  };

  const groupedRegionOptions = useMemo(() => {
    if (!weatherDropdownOptions || weatherDropdownOptions.length === 0) return [];
    const districtMap = new Map();
    weatherDropdownOptions.forEach((opt) => {
      if (opt.type === "district") {
        if (!districtMap.has(opt.districtName)) {
          districtMap.set(opt.districtName, { district: opt, blocks: [] });
        }
      }
    });
    weatherDropdownOptions.forEach((opt) => {
      if (opt.type === "block" && districtMap.has(opt.districtName)) {
        districtMap.get(opt.districtName).blocks.push(opt);
      }
    });
    return Array.from(districtMap.values());
  }, [weatherDropdownOptions]);

  const handleRegionSelect = (value) => {
    setSelectedRegionValue(value);
    if (!value) {
      setSelectedRegions([]);
      setFormData((prev) => ({ ...prev, region: [] }));
      setValidationErrors((prev) => ({ ...prev, region: "Please select a region" }));
      return;
    }
    const selectedOption = weatherDropdownOptions.find((opt) => opt.value === value);
    if (selectedOption) {
      const regionSelected = [{ region_id: selectedOption.regionId }];
      setSelectedRegions(regionSelected);
      setFormData((prev) => ({ ...prev, region: regionSelected }));
      setValidationErrors((prev) => ({ ...prev, region: "" }));
    }
  };

  // ─── Format helpers ───
  const formatDateTimeForInput = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const formatDateTimeCustom = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${dd}/${mm}/${yyyy}, ${hours}:${minutes} ${ampm}`;
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear());
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");
    return `${dd}-${mm}-${yyyy} ${formattedHours}:${minutes} ${ampm}`;
  };

  const formatDateTimeForDisplay = (date) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${dd}-${mm}-${yyyy} ${hours}:${minutes} ${ampm}`;
  };

  const formatDateTimeForPayload = (dateTimeString) => {
    if (!dateTimeString) return "";
    const date = new Date(dateTimeString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, "0");
    return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
  };

  // ─── SLA/Priority calculation helpers ───
  const addDaysExcludingSundays = (startDate, daysToAdd) => {
    let resultDate = new Date(startDate);
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      resultDate.setDate(resultDate.getDate() + 1);
      if (resultDate.getDay() !== 0) addedDays++;
    }
    return resultDate;
  };

  const calculateDefaultDateTime = (maxResTimeValue, maxResTimeType) => {
    let currentDate = new Date();
    switch (maxResTimeType.toLowerCase()) {
      case "days":
        currentDate = addDaysExcludingSundays(currentDate, maxResTimeValue);
        break;
      case "hours":
        currentDate.setHours(currentDate.getHours() + maxResTimeValue);
        if (currentDate.getDay() === 0) currentDate.setDate(currentDate.getDate() + 1);
        break;
      case "minutes":
        currentDate.setMinutes(currentDate.getMinutes() + maxResTimeValue);
        if (currentDate.getDay() === 0) currentDate.setDate(currentDate.getDate() + 1);
        break;
      default:
        break;
    }
    currentDate.setHours(currentDate.getHours() + 5);
    currentDate.setMinutes(currentDate.getMinutes() + 30);
    return currentDate.toISOString().slice(0, 16);
  };

  const extractDateTime = (displayMessage) => {
  const match = displayMessage.match(
    /\((\d{2}\/\d{2}\/\d{4}),\s*(\d{1,2}:\d{2}\s*(?:AM|PM))\)/i
  );
  if (match) {
    const [, date, time] = match; // ✅ skip index 0 (full match), grab groups 1 & 2
    const formattedDate = date.replace(/\//g, "-");
    return `${formattedDate}, ${time}`; // ✅ "26-03-2026, 4:47 PM"
  }
  return null;
};

  const getCurrentDateTimeLocal = () => formatDateTimeForInput(new Date());

  // ─── Init effects ───
  useEffect(() => {
    const now = new Date();
    const currentDateTime = formatDateTimeForInput(now);
    setFormData((prev) => ({ ...prev, ticketDateAndTimeString: currentDateTime }));
    setDefaultDateTime(formatDateTimeForInput(now));
    setDisplayTime(formatDateTimeForDisplay(now));
  }, []);

  useEffect(() => {
    fetchUserProfile();
  }, []);

  useEffect(() => {
    getUserProfile();
    buildRegionOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch priorities from SLA list
  useEffect(() => {
    const fetchPriorities = async () => {
      try {
        const response = await getData(getAllSLA);
        if (response && Array.isArray(response)) {
          const priorityList = response
            .filter((item) => item.activeStatus && !item.is_deleted)
            .map((item) => item.priority);
          setPriorities(priorityList);
        }
      } catch (error) {
        console.error("Error fetching priorities:", error);
      }
    };
    fetchPriorities();
  }, []);

  // Recalculate SLA display whenever priorityTime changes
  useEffect(() => {
    if (priorityTime && priorityTime.maxResTimeValue && priorityTime.maxResTimeType) {
      const now = new Date();
      let maxDate = new Date(now);
      switch (priorityTime.maxResTimeType.toLowerCase()) {
        case "minutes":
          maxDate.setMinutes(now.getMinutes() + priorityTime.maxResTimeValue);
          break;
        case "hours":
          maxDate.setHours(now.getHours() + priorityTime.maxResTimeValue);
          break;
        case "days":
          maxDate = addDaysExcludingSundays(now, priorityTime.maxResTimeValue);
          break;
        default:
          break;
      }
      setDisplayTime(
        `Maximum resolution time: ${priorityTime.maxResTimeValue} ${priorityTime.maxResTimeType} (${formatDateTimeCustom(maxDate)})`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priorityTime]);

  // Recalculate defaultDateTime whenever priorityTime changes
  useEffect(() => {
    if (priorityTime && priorityTime.maxResTimeValue && priorityTime.maxResTimeType) {
      const calculatedDateTime = calculateDefaultDateTime(
        priorityTime.maxResTimeValue,
        priorityTime.maxResTimeType
      );
      setDefaultDateTime(calculatedDateTime);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priorityTime]);

  // ─── Data fetchers ───
  const fetchUserProfile = async () => {
    setLoader(true);
    try {
      const response = await getData(getThemeURL);
      if (response && Array.isArray(response) && response.length > 0) {
        const userData = response[0];
        setUserId(response[0].id);
        setUserProfile(response[0]);
        const fullName = userData.last_name
          ? `${userData.first_name} ${userData.last_name}`
          : userData.first_name || "";
        setFormData((prev) => ({
          ...prev,
          customerName: fullName,
          phoneNumber: userData.phone_number || "",
        }));
        if (fullName || userData.phone_number) {
          setIsPrefilled(true);
          setAreFieldsEnabled(false);
        } else {
          setAreFieldsEnabled(true);
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    } finally {
      setLoader(false);
    }
  };

  const getUserProfile = async () => {
    setLoader(true);
    try {
      const userProfileRes = await getData(getThemeURL);
      if (userProfileRes && userProfileRes.length > 0) {
        const userData = userProfileRes[0];
        setUserProfiles(userProfileRes);
        setUserLevel(userProfileRes[0]?.userLevel);
        setUserProfile(userProfileRes[0]);
        const fullName = userData.last_name
          ? `${userData.first_name} ${userData.last_name}`
          : userData.first_name || "";
        setFormData((prev) => ({
          ...prev,
          customerName: fullName,
          phoneNumber: userData.phone_number || "",
        }));
        if (fullName || userData.phone_number) {
          setIsPrefilled(true);
          setAreFieldsEnabled(false);
        } else {
          setAreFieldsEnabled(true);
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      toast.error("Failed to fetch user profile", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } finally {
      setLoader(false);
    }
  };

  const clearRequestorInfo = () => {
    setFormData((prev) => ({ ...prev, customerName: "", phoneNumber: "" }));
    setIsPrefilled(false);
    setAreFieldsEnabled(true);
    setValidationErrors((prev) => ({ ...prev, customerName: "", phoneNumber: "" }));
  };

  // eslint-disable-next-line no-unused-vars
  const fetchAllRoles = async () => {
    try {
      const rolearr = await getData(grievanceDepartmentslist);
      const sortedRoles = rolearr.sort((a, b) => (a.name > b.name ? 1 : -1));
      const roleListData = sortedRoles.map((role) => ({ label: role.name, value: role.id }));
      setRoleList(roleListData);
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles");
    }
  };

  const fetchIssueTypes = async (id) => {
    try {
      if (!id) return;
      const request = ["GRV_CAT_TYPE"];
      const response = await postDataWithBody(getCategory.replace("ID", id), request, {});
      if (Array.isArray(response)) setIssueTypes(response);
    } catch (error) {
      console.error("Error fetching issue types:", error);
    }
  };

  const categoryCards = useMemo(() => {
    return issueTypes.map((issue) => {
      const key = issue.value?.toLowerCase().trim();
      const style = categoryStyleMap[key] || defaultStyle;
      return {
        label: issue.value,
        id: issue.id,
        icon: style.icon,
        color: style.color,
        border: style.border,
        department_id: issue.department_id,
        department_name: issue.department_name,
      };
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [issueTypes]);

  const fetchSubIssueTypes = async (issueTypeId) => {
    try {
      const response = await getData(
        getSubIssueTypes.replace("ID", issueTypeId).replace("StateId", stateId)
      );
      if (Array.isArray(response)) {
        setSubIssueTypes(response);
      } else {
        setSubIssueTypes([]);
      }
    } catch (error) {
      console.error("Error fetching sub-issue types:", error);
      setSubIssueTypes([]);
    }
  };

  const fetchResolutionMethods = async (id) => {
    try {
      if (!id) return;
      const request = ["GRV_RES_CAT"];
      const response = await postDataWithBody(getResMethods.replace("ID", id), request, {});
      if (Array.isArray(response)) setResMethods(response);
    } catch (error) {
      console.error("Error fetching resolution methods:", error);
    }
  };

  const fetchPriorityData = async (selectedPriority) => {
    try {
      const response = await getData(getAllPriority.replace("PRIORITY", selectedPriority));
      setPriorityTime(response);
    } catch (error) {
      console.error("Error fetching priority data:", error);
    }
  };

  useEffect(() => {
    if (stateId) fetchResolutionMethods(stateId);
  }, [stateId]);

  // ─── Editor ───
  const onEditorStateChange = (newEditorState) => {
    const plainText = newEditorState.getCurrentContent().getPlainText();
    const textLength = plainText.length;
    setEditorState(newEditorState);
    setCharacterCount(textLength);
    const html = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    setFormData((prev) => ({ ...prev, description: html }));
    if (textLength > MAX_LENGTH) {
      setValidationErrors((prev) => ({
        ...prev,
        description: `Maximum length of ${MAX_LENGTH} characters exceeded. Please reduce the content.`,
      }));
    } else if (validationErrors.description && textLength <= MAX_LENGTH) {
      setValidationErrors((prev) => ({ ...prev, description: "" }));
    }
  };

  // ─── Input handlers ───
  const handleSubjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
    setFormData({ ...formData, subject: value });
    if (value) setValidationErrors({ ...validationErrors, subject: "" });
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let errorMessage = "";
    let updatedValue = value;

    switch (id) {
      case "phoneNumber":
        if (value && !/^\d*$/.test(value)) {
          errorMessage = "Phone number can only contain digits";
          updatedValue = formData.phoneNumber;
        } else if (value.length > 0 && !/^[6-9]/.test(value)) {
          errorMessage = "Phone number must start with 6, 7, 8, or 9";
          updatedValue = formData.phoneNumber;
        } else if (value.length > 10) {
          errorMessage = "Phone number cannot exceed 10 digits";
          updatedValue = value.slice(0, 10);
        }
        break;
      case "email":
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errorMessage = "Please enter a valid email address";
        }
        break;
      case "issueTypeId":
        if (value) {
          const selectedCat = issueTypes.find(
            (issue) => issue.id && issue.id.toString() === value.toString()
          );
          if (selectedCat) {
            setFormData((prev) => ({
              ...prev,
              issueTypeId: value,
              issueTypeSubCatId: "",
              assignedTeam: selectedCat.department_id ? selectedCat.department_id.toString() : "",
              departmentId: selectedCat.department_id || "",
              departmentName: selectedCat.department_name || "",
            }));
            fetchSubIssueTypes(value);
            setValidationErrors((prev) => ({ ...prev, issueTypeId: "", assignedTeam: "" }));
            return;
          }
        } else {
          setSubIssueTypes([]);
          setFormData((prev) => ({
            ...prev,
            issueTypeId: "",
            issueTypeSubCatId: "",
            assignedTeam: "",
            departmentId: "",
            departmentName: "",
          }));
          return;
        }
        break;
      case "ticketDateAndTimeString":
        errorMessage = validateDateTime(value);
        break;
      case "resSLADateAndTimeString":
        errorMessage = validateResolutionDateTime(value);
        break;
      default:
        break;
    }

    setFormData({ ...formData, [id]: updatedValue });
    setValidationErrors({ ...validationErrors, [id]: errorMessage });
  };

  // ─── Validations ───
  const validateDateTime = (dateTimeString) => {
    if (!dateTimeString) return "Ticket Created Date & Time is required";
    const selectedDate = new Date(dateTimeString);
    const currentDate = new Date();
    if (isNaN(selectedDate)) return "Invalid date format";
    if (selectedDate > currentDate) return "Date and Time cannot be in the future";
    return "";
  };

  const validateResolutionDateTime = (dateTimeString) => {
    if (!dateTimeString) {
      return "Resolution Date and Time is required when priority time type is Days";
    }
    const selectedDateTime = new Date(dateTimeString);
    const currentDateTime = new Date();
    selectedDateTime.setSeconds(0, 0);
    currentDateTime.setSeconds(0, 0);
    if (selectedDateTime < currentDateTime) {
      return "Resolution Date and Time cannot be in the past. Please choose a valid future date and time.";
    }
    return "";
  };

  const validateForm = () => {
    const plainText = editorState.getCurrentContent().getPlainText();
    const textLength = plainText.length;

    const errors = {
      ticketDateAndTimeString: validateDateTime(formData.ticketDateAndTimeString),
      customerName: !formData.customerName ? "Requestor Name is required" : "",
      phoneNumber: !formData.phoneNumber
        ? "Requestor Contact Number is required"
        : !/^[6-9]\d{9}$/.test(formData.phoneNumber)
          ? "Requestor Contact Number must start with 6, 7, 8, or 9 and be exactly 10 digits"
          : "",
      email: !formData.email
        ? "Requestor Email Address is required"
        : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
          ? "Please enter a valid email address"
          : "",
      resolutionMethodId: !formData.resolutionMethodId
        ? "Preferred Resolution Method is required"
        : "",
      region: selectedRegions.length === 0 ? "Please select a region" : "",
      issueTypeId: !formData.issueTypeId ? "Category is required" : "",
      issueTypeSubCatId: !formData.issueTypeSubCatId ? "Subcategory is required" : "",
      priority: !formData.priority ? "Priority is required" : "",
      // assignedTeam: !formData.assignedTeam ? "Support Team is required" : "",
      subject: !formData.subject ? "Subject is required" : "",
      description: !editorState.getCurrentContent().hasText()
        ? "Description is required"
        : textLength > MAX_LENGTH
          ? `Maximum length of ${MAX_LENGTH} characters exceeded. Please reduce the content.`
          : "",
      ...(priorityTime && priorityTime.maxResTimeType === "Days"
        ? { resolutionDateTime: validateResolutionDateTime(defaultDateTime) }
        : {}),
    };

    setValidationErrors(errors);
    return !Object.values(errors).some((error) => error !== "");
  };

  // ─── File handling ───
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
    const maxSize = 1 * 1024 * 1024;
    const maxFiles = 5;
    const newErrors = [];

    if (selectedImages.length + files.length > maxFiles) {
      newErrors.push(`You can only upload a maximum of ${maxFiles} files.`);
      e.target.value = "";
      setFileErrors(newErrors);
      return;
    }

    const validFiles = [];
    files.forEach((file) => {
      if (!allowedTypes.includes(file.type)) {
        newErrors.push(`File "${file.name}" has an invalid type. Only JPG, PNG, GIF, and PDF are allowed.`);
        return;
      }
      if (file.size > maxSize) {
        newErrors.push(`File "${file.name}" exceeds the 1MB limit.`);
        return;
      }
      validFiles.push(file);
    });

    setFileErrors(newErrors);
    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImages((prevImages) => [...prevImages, { file, preview: reader.result }]);
      };
      reader.readAsDataURL(file);
    });
    e.target.value = "";
  };

  const removeImage = (indexToRemove) => {
    setSelectedImages((prevImages) => prevImages.filter((_, index) => index !== indexToRemove));
  };

  const isPdf = (file) => file.type === "application/pdf";

  // ─── Submit ───
  const handleSubmit = async () => {
    if (!validateForm()) {
      toast.error("Please fill all mandatory fields correctly", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        toastId: "mandatory-fields-error",
        pauseOnHover: false,
      });
      return;
    }

    const dateError = validateDateTime(formData.ticketDateAndTimeString);
    if (dateError) {
      setValidationErrors((prev) => ({ ...prev, ticketDateAndTimeString: dateError }));
      toast.error(dateError, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
      return;
    }

    if (priorityTime && priorityTime.maxResTimeType === "Days") {
      const resolutionDateError = validateResolutionDateTime(defaultDateTime);
      if (resolutionDateError) {
        setValidationErrors((prev) => ({ ...prev, resolutionDateTime: resolutionDateError }));
        toast.error(resolutionDateError, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
        return;
      }
    }

    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();

      let resolutionDateTime;
      if (priorityTime && priorityTime.maxResTimeType === "Days" && defaultDateTime) {
        resolutionDateTime = formatDateTimeForPayload(defaultDateTime);
      } else {
        const extractedDateTime = extractDateTime(displayTime);
        resolutionDateTime = extractedDateTime || formatDateTimeForPayload(defaultDateTime);
      }

      const selectedRegionId = selectedRegions.length > 0 ? selectedRegions[0].region_id : null;

      const grievanceData = {
        customerName: formData.customerName,
        phoneNumber: formData.phoneNumber,
        email: formData.email,
        resolutionMethodId: parseInt(formData.resolutionMethodId),
        regionId: selectedRegionId,
        issueTypeId: parseInt(formData.issueTypeId),
        issueTypeSubCatIds: [formData.issueTypeSubCatId],
        // ticketDateAndTimeString: formatDateTime(formData.ticketDateAndTimeString),
        resSLADateAndTimeString: resolutionDateTime,
        priority: formData.priority,
        assignedTeam: '',
        description: formData.description,
        subject: formData.subject,
        is_deleted: false,
        createdBy: userId,
        userLevel: userLevel,
        // handledLevel: userProfile?.user_level,
        // state_id: stateId,
        // user_region_map: selectedRegions,
      };

      formDataToSend.append("grievance", JSON.stringify(grievanceData));

      if (selectedImages && selectedImages.length > 0) {
        selectedImages.forEach((imgObj) => {
          if (imgObj.file instanceof File) formDataToSend.append("files", imgObj.file);
        });
      } else {
        const emptyBlob = new Blob([], { type: "application/octet-stream" });
        formDataToSend.append("files", emptyBlob, "empty.bin");
      }

      const response = await postDataWithFiles(createGrievance, formDataToSend);

      if (response.status === "success") {
        toast.success(response.msg || "Grievance submitted successfully!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        navigate("../grievance");
      } else {
        throw new Error(response.msg || "Failed to submit grievance");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error(error.message || "Failed to submit grievance", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
        toastId: "submit-fields-error",
        pauseOnHover: false,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelClick = () => setShowCancelModal(true);

  const handleConfirmCancel = () => {
    setFormData({
      customerName: "",
      phoneNumber: "",
      email: "",
      resolutionMethodId: "",
      subject: "",
      description: "",
      issueTypeId: "",
      issueTypeSubCatId: "",
      ticketDateAndTimeString: "",
      resSLADateAndTimeString: "",
      priority: "",
      assignedTeam: "",
      departmentId: "",
      departmentName: "",
      region: [],
    });
    setValidationErrors({
      customerName: "",
      phoneNumber: "",
      email: "",
      resolutionMethodId: "",
      subject: "",
      description: "",
      issueTypeId: "",
      issueTypeSubCatId: "",
      ticketDateAndTimeString: "",
      resSLADateAndTimeString: "",
      priority: "",
      assignedTeam: "",
      resolutionDateTime: "",
      region: "",
    });
    setSelectedRegions([]);
    setSelectedRegionValue("");
    setSelectedCategory(null);
    setPriorityTime(null);
    setDisplayTime(formatDateTimeForDisplay(new Date()));
    setShowCancelModal(false);
  };

  // ─── Render helpers ───

  // Step computation
  const step1Done = !!selectedCategory && !!formData.issueTypeId;
  const step2Done =
    step1Done && !!formData.phoneNumber && !!formData.email && !!formData.resolutionMethodId;
  const step3Done =
    step2Done &&
    selectedRegions.length > 0 &&
    !!formData.issueTypeSubCatId &&
    !!formData.priority &&
    !!formData.subject &&
    editorState.getCurrentContent().hasText();

  // Char progress
  const charPercent = Math.min((characterCount / MAX_LENGTH) * 100, 100);
  const charBarClass =
    characterCount > MAX_LENGTH
      ? "rt-char-progress-bar rt-char-progress-bar--danger"
      : characterCount > MAX_LENGTH * 0.8
        ? "rt-char-progress-bar rt-char-progress-bar--warning"
        : "rt-char-progress-bar";

  // Error helper component
  const ErrorMsg = ({ msg }) =>
    msg ? (
      <div className="rt-error-msg">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
          <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.437-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </svg>
        <span>{msg}</span>
      </div>
    ) : null;

  return (
    <>
      <div className="raise-ticket-wrapper">
        {/* ═══ Page Header ═══ */}
        <div className="rt-page-header">
          <div className="rt-page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 16 16">
              <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H9.5l-2 2v-2H2a1 1 0 0 1-1-1V3zm0 7a1 1 0 0 1 1-1h4.5l2 2V10H14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z" />
            </svg>
          </div>
          <div>
            <h5 className="rt-page-header-title">Raise a Ticket</h5>
            <p className="rt-page-header-subtitle">Submit a new grievance or service request</p>
          </div>
        </div>

        <Loader show={loader} type="body" stack="vertical" message="Loading Data" />

        {/* ═══ Step Progress Indicator ═══ */}
        <div className="rt-stepper">
          <div className={`rt-step ${step1Done ? "rt-step--completed" : "rt-step--active"}`}>
            <div className="rt-step-number">{step1Done ? "✓" : "1"}</div>
            <span className="rt-step-label">Category</span>
          </div>
          <div className={`rt-step-connector ${step1Done ? "rt-step-connector--completed" : ""}`} />
          <div className={`rt-step ${step2Done ? "rt-step--completed" : step1Done ? "rt-step--active" : ""}`}>
            <div className="rt-step-number">{step2Done ? "✓" : "2"}</div>
            <span className="rt-step-label">Information</span>
          </div>
          <div className={`rt-step-connector ${step2Done ? "rt-step-connector--completed" : ""}`} />
          <div className={`rt-step ${step3Done ? "rt-step--completed" : step2Done ? "rt-step--active" : ""}`}>
            <div className="rt-step-number">{step3Done ? "✓" : "3"}</div>
            <span className="rt-step-label">Details</span>
          </div>
        </div>

        {/* ═══ STEP 1 — Category Selection ═══ */}
        <div className="rt-section rt-category-section">
          <div className="rt-section-header">
            <div className="rt-section-icon-badge rt-section-icon-badge--purple">📋</div>
            <h5 className="rt-section-title">
              Type of Grievance <span className="text-danger">*</span>
            </h5>
          </div>
          <p className="rt-section-subtitle">
            Please select the category that best describes your grievance
          </p>

          <div className="rt-category-grid">
            {categoryCards.map((card) => (
              <div
                key={card.label}
                className={`rt-category-card ${selectedCategory === card.label ? "rt-category-card--active" : ""}`}
                style={{ "--card-bg": card.color, "--card-border": card.border }}
                onClick={() => handleCategoryCardSelect(card)}
              >
                <span className="rt-category-card-icon">{card.icon}</span>
                <span className="rt-category-card-label">{card.label}</span>
              </div>
            ))}
          </div>
          {validationErrors.issueTypeId && !selectedCategory && (
            <ErrorMsg msg={validationErrors.issueTypeId} />
          )}
        </div>

        {/* ═══ STEP 2 & 3 — Form (after category selection) ═══ */}
        {selectedCategory && (
          <div className="rt-form-body">

            {/* ── Requestor Information ── */}
            <div className="rt-section">
              <div className="rt-section-header">
                <div className="rt-section-icon-badge rt-section-icon-badge--blue">👤</div>
                <h5 className="rt-section-title">Requestor Information</h5>
              </div>

              <div className="row mb-3" style={{ marginTop: "14px" }}>
                <div className="col-md-6">
                  <label htmlFor="customerName" className="rt-label">
                    Requestor Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control rt-input ${validationErrors.customerName ? "is-invalid" : ""}`}
                    id="customerName"
                    value={formData.customerName}
                    onChange={handleInputChange}
                    disabled={!areFieldsEnabled}
                    placeholder="Enter full name"
                  />
                  <ErrorMsg msg={validationErrors.customerName} />
                </div>

                <div className="col-md-6">
                  <label htmlFor="phoneNumber" className="rt-label">
                    Contact Number<span className="text-danger">*</span>
                  </label>
                  <div className="d-flex align-items-center">
                    <input
                      type="tel"
                      className={`form-control rt-input ${validationErrors.phoneNumber ? "is-invalid" : ""}`}
                      id="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                      maxLength={15}
                      disabled={!areFieldsEnabled}
                      style={{ flex: 1 }}
                      placeholder="e.g. 9876543210"
                    />
                    {isPrefilled && (
                      <button
                        type="button"
                        className="btn rt-clear-btn ms-2"
                        onClick={clearRequestorInfo}
                        title="Clear prefilled information"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z" />
                        </svg>
                      </button>
                    )}
                  </div>
                  <ErrorMsg msg={validationErrors.phoneNumber} />
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label htmlFor="email" className="rt-label">
                    Email Address<span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className={`form-control rt-input ${validationErrors.email ? "is-invalid" : ""}`}
                    id="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="example@domain.com"
                  />
                  <ErrorMsg msg={validationErrors.email} />
                </div>

                <div className="col-md-6">
                  <label htmlFor="resolutionMethodId" className="rt-label">
                    Preferred Resolution Method<span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select rt-input ${validationErrors.resolutionMethodId ? "is-invalid" : ""}`}
                    id="resolutionMethodId"
                    value={formData.resolutionMethodId}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Resolution Method</option>
                    {resMethods.map((resMethod) => (
                      <option key={resMethod.id} value={resMethod.id}>
                        {resMethod.value}
                      </option>
                    ))}
                  </select>
                  <ErrorMsg msg={validationErrors.resolutionMethodId} />
                </div>
              </div>
            </div>

            {/* ── Grievance Details ── */}
            <div className="rt-section">
              <div className="rt-section-header">
                <div className="rt-section-icon-badge rt-section-icon-badge--green">📝</div>
                <h5 className="rt-section-title">Grievance Details</h5>
              </div>

              {/* Region & Subcategory */}
              <div className="row mb-3" style={{ marginTop: "14px" }}>
                <div className="col-md-6">
                  <label htmlFor="region" className="rt-label">
                    Region<span className="text-danger">*</span>
                  </label>
                  {dropdownLoading ? (
                    <input
                      type="text"
                      className="form-control rt-input"
                      disabled
                      placeholder="Loading regions..."
                    />
                  ) : (
                    <select
                      className={`form-select rt-input ${validationErrors.region ? "is-invalid" : ""}`}
                      value={selectedRegionValue}
                      onChange={(e) => handleRegionSelect(e.target.value)}
                    >
                      <option value="">-- Select District / Block --</option>
                      {groupedRegionOptions.map((group) => (
                        <optgroup key={group.district.value} label={group.district.districtName}>
                          <option value={group.district.value}>
                            {group.district.districtName} (District)
                          </option>
                          {group.blocks.map((block) => (
                            <option key={block.value} value={block.value}>
                              {block.label} ({block.districtName})
                            </option>
                          ))}
                        </optgroup>
                      ))}
                    </select>
                  )}
                  <ErrorMsg msg={validationErrors.region} />
                </div>

                <div className="col-md-6">
                  <label htmlFor="issueTypeSubCatId" className="rt-label">
                    Subcategory<span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select rt-input ${validationErrors.issueTypeSubCatId ? "is-invalid" : ""}`}
                    id="issueTypeSubCatId"
                    value={formData.issueTypeSubCatId}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData({ ...formData, issueTypeSubCatId: value });
                      if (value && validationErrors.issueTypeSubCatId) {
                        setValidationErrors({ ...validationErrors, issueTypeSubCatId: "" });
                      }
                    }}
                    disabled={subIssueTypes.length === 0}
                  >
                    <option value="">
                      {subIssueTypes.length === 0 ? "Loading subcategories..." : "Select Subcategory"}
                    </option>
                    {subIssueTypes.map((subIssue) => (
                      <option key={subIssue.id} value={subIssue.id}>
                        {subIssue.value}
                      </option>
                    ))}
                  </select>
                  <ErrorMsg msg={validationErrors.issueTypeSubCatId} />
                </div>
              </div>

              {/* Support Team + Priority + (optional) Resolution Date */}
              <div className="row mb-3">
                {/* Support Team — auto-filled from category */}
                {/* <div className="col-md-6">
                  <label htmlFor="departmentName" className="rt-label">
                    Support Team<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control rt-input ${!formData.departmentName && validationErrors.assignedTeam ? "is-invalid" : ""}`}
                    id="departmentName"
                    value={formData.departmentName || ""}
                    readOnly
                    disabled
                    placeholder="Auto-filled based on category"
                  />
                  {!formData.departmentName && (
                    <ErrorMsg msg={validationErrors.assignedTeam} />
                  )}
                </div> */}

                {/* Priority dropdown — narrows when Resolution Date column appears */}
                <div className={priorityTime && priorityTime.maxResTimeType === "Days" ? "col-md-3" : "col-md-6"}>
                  <label htmlFor="priority" className="rt-label">
                    Priority<span className="text-danger">*</span>
                  </label>
                  <select
                    className={`form-select rt-input ${validationErrors.priority ? "is-invalid" : ""}`}
                    id="priority"
                    value={formData.priority}
                    onChange={(e) => {
                      const selectedPriority = e.target.value;
                      setFormData({ ...formData, priority: selectedPriority });
                      setValidationErrors({ ...validationErrors, priority: "" });
                      if (selectedPriority) {
                        fetchPriorityData(selectedPriority);
                      } else {
                        setPriorityTime(null);
                        setDisplayTime(formatDateTimeForDisplay(new Date()));
                      }
                    }}
                  >
                    <option value="">Select Priority</option>
                    {priorities.map((priority, index) => (
                      <option key={index} value={priority}>
                        {priority}
                      </option>
                    ))}
                  </select>
                  <ErrorMsg msg={validationErrors.priority} />
                  {/* SLA hint text shown below dropdown */}
                  {displayTime && formData.priority && (
                    <div className="rt-hint mt-1">{displayTime}</div>
                  )}
                </div>

                {/* Resolution Date & Time — only shown when maxResTimeType === "Days" */}
                {priorityTime && priorityTime.maxResTimeType === "Days" && (
                  <div className="col-md-3">
                    <label htmlFor="resSLADateAndTimeString" className="rt-label">
                      Resolution Date &amp; Time
                    </label>
                    <input
                      type="datetime-local"
                      className={`form-control rt-input ${validationErrors.resolutionDateTime ? "is-invalid" : ""}`}
                      id="resSLADateAndTimeString"
                      value={defaultDateTime}
                      onChange={(e) => {
                        const selectedValue = e.target.value;
                        setDefaultDateTime(selectedValue);
                        const error = validateResolutionDateTime(selectedValue);
                        setValidationErrors({ ...validationErrors, resolutionDateTime: error });
                      }}
                      min={getCurrentDateTimeLocal()}
                      disabled={true}
                    />
                    <ErrorMsg msg={validationErrors.resolutionDateTime} />
                  </div>
                )}
              </div>

              {/* Ticket Date (hidden/auto) */}
              <input
                type="hidden"
                id="ticketDateAndTimeString"
                value={formData.ticketDateAndTimeString}
              />

              {/* Subject */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="subject" className="rt-label">
                    Subject<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control rt-input ${validationErrors.subject ? "is-invalid" : ""}`}
                    id="subject"
                    value={subject}
                    onChange={handleSubjectChange}
                    maxLength={100}
                    placeholder="Brief summary of your grievance"
                  />
                  <ErrorMsg msg={validationErrors.subject} />
                </div>
              </div>

              {/* Description */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="description" className="rt-label">
                    Description<span className="text-danger">*</span>
                  </label>
                  <div className={`rt-editor-wrapper ${validationErrors.description ? "rt-editor-error" : ""}`}>
                    <Editor
                      editorState={editorState}
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      onEditorStateChange={onEditorStateChange}
                      toolbar={{
                        options: ["inline", "blockType", "fontSize", "list", "textAlign", "colorPicker", "link", "emoji", "history"],
                        inline: { options: ["bold", "italic", "underline", "strikethrough"] },
                      }}
                      editorStyle={{ minHeight: "150px", padding: "0 10px", border: "none" }}
                    />
                  </div>
                  {/* Character Count Progress Bar */}
                  <div className="rt-char-count-wrapper">
                    <div className="rt-char-progress">
                      <div className={charBarClass} style={{ width: `${charPercent}%` }} />
                    </div>
                    <div className={`rt-char-count ${characterCount > MAX_LENGTH ? "rt-char-count--danger" : ""}`}>
                      {characterCount} / {MAX_LENGTH} characters
                      {characterCount > MAX_LENGTH && " — Limit exceeded"}
                    </div>
                  </div>
                  <ErrorMsg msg={validationErrors.description} />
                </div>
              </div>

              {/* Attachments */}
              <div className="row mb-3">
                <div className="col-md-12">
                  <label htmlFor="attachments" className="rt-label">
                    Attachments
                  </label>
                  <div className="rt-upload-area">
                    <input
                      type="file"
                      className="d-none"
                      id="attachments"
                      onChange={handleImageChange}
                      multiple
                      accept=".jpg,.jpeg,.png,.gif,.pdf"
                    />
                    <label htmlFor="attachments" className="rt-upload-label">
                      <div className="rt-upload-text">
                        <span>Click to upload</span>
                      </div>
                      <span className="rt-upload-hint">JPG, PNG, GIF, PDF — max 1 MB each, up to 5 files</span>
                    </label>

                    {selectedImages.length > 0 && (
                      <div className="rt-file-previews">
                        {selectedImages.map((imgObj, index) => (
                          <div key={index} className="rt-file-preview-item">
                            {isPdf(imgObj.file) ? (
                              <div className="rt-pdf-thumb">
                                <span>PDF</span>
                                <small>{imgObj.file.name}</small>
                              </div>
                            ) : (
                              <img src={imgObj.preview} alt={`preview-${index}`} className="rt-img-thumb" />
                            )}
                            <button onClick={() => removeImage(index)} className="rt-remove-file" title="Remove">✕</button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {fileErrors.length > 0 && (
                    <div className="mt-2">
                      {fileErrors.map((error, index) => (
                        <ErrorMsg key={index} msg={error} />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* ═══ Action Buttons ═══ */}
            <div className="rt-actions">
              <button
                className="rt-btn rt-btn-submit"
                onClick={handleSubmit}
                disabled={isSubmitting || isTextFieldDisable}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" />
                    Submitting...
                  </>
                ) : (
                  <>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z" />
                    </svg>
                    Save & Submit
                  </>
                )}
              </button>
              <button className="rt-btn rt-btn-cancel" onClick={handleCancelClick}>
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>

      <ToastContainer />

      {/* ═══ Cancel Confirmation Modal ═══ */}
      <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} centered className="rt-modal">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="rt-modal-icon">⚠️</div>
          <div>
            <strong style={{ display: "block", marginBottom: "4px" }}>Clear all fields?</strong>
            This will reset all input values. You'll need to fill them in again.
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="rt-btn rt-btn-cancel" onClick={() => setShowCancelModal(false)}>
            No, keep data
          </button>
          <button className="rt-btn rt-btn-submit" onClick={handleConfirmCancel}>
            Yes, clear all
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RaiseTicket;